import { render, staticRenderFns } from "./StepsPart2.vue?vue&type=template&id=8fdb4204&scoped=true&"
import script from "./StepsPart2.vue?vue&type=script&lang=js&"
export * from "./StepsPart2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fdb4204",
  null
  
)

export default component.exports